export default "__VITE_ASSET__DWmHxcBK__"